
<div class="content-container">
  <div *ngFor="let step of steps; let i = index" class="tab-panel">
    <div  *ngIf="activeIndex === i">
      <ng-container *ngTemplateOutlet="step.template"></ng-container>
    </div>
  </div>
</div>

    <div class="grid">
      <div class="col">
        <ng-container *ngTemplateOutlet="customPreviousButton || defaultPreviousButton"></ng-container>
      </div>
      <div class="col">

        <div class="grid p-fluid justify-content-center grid-nogutter" *ngIf="stepsArray.length > 1 && !isStepDisabled">
          <div class="step disable-pointer-events" *ngFor="let _ of stepsArray; let i = index" [class.active]="i === activeIndex" ></div>
        </div>
      </div>
      <div class="col">
        <div class="flex justify-content-end align-items-center gap-5">
          <i *ngIf="errors.length > 0" class="pi pi-exclamation-circle alert-error" [pTooltip]="tooltipErrors"></i>
          <ng-container *ngTemplateOutlet="customNextButton || defaultNextButton"
                [class.botao-proximo]="isNextStepEnabled"
                [class.disabled]="!isNextStepEnabled"></ng-container>
        </div>
      </div>
    </div>

    <ng-template #defaultPreviousButton>
      <button type="button" class="s-step__button-previous" (click)="previousStep()" [disabled]="activeIndex === 0">
        <i class="pi pi-arrow-left mr-3"></i>Anterior</button>
    </ng-template>


    <ng-template #defaultNextButton>
      <button class="s-step__button-next"
              (click)="nextStep()"
              [disabled]="activeIndex === totalSteps - 1 || !isNextStepEnabled"
              [ngClass]="{'disabled': !isNextStepEnabled}">
        Próximo <i class="pi pi-arrow-right ml-3"></i>
      </button>
    </ng-template>

    <ng-template #tooltipErrors>
      <ul class="ul-0">
          <li *ngFor="let error of errors">
              <ng-container  *ngFor="let err of error.errors">
                  <ng-container *ngIf="err == 'required'">
                      {{  'O campo "{0}" é obrigatório.'  | splitReplaceText: this.environmentText[error.key]}}
                  </ng-container>
                  <ng-container *ngIf="err == 'email' || err == 'cnpj' || err == 'taxId' || err == 'mask'">
                      {{  'O campo "{0}" é inválido.'  | splitReplaceText: this.environmentText[error.key]}}
                  </ng-container>
                  <ng-container *ngIf="err == 'minlength'">
                      {{  'O campo "{0}" deve ter no mínimo {1} caracteres.'  | splitReplaceText: this.environmentText[error.key]}}
                  </ng-container>
                  <ng-container *ngIf="err == 'maxlength'">
                      {{  'O campo "{0}" deve ter no máximo {1} caracteres.'  | splitReplaceText: this.environmentText[error.key]}}
                  </ng-container>
                  <ng-container *ngIf="err == 'pattern'">
                      {{  'O campo "{0}" inválido.'  | splitReplaceText: this.environmentText[error.key]}}
                  </ng-container>
              </ng-container>
          </li>
      </ul>
  </ng-template>


